import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CartComponent } from '../../products/cart/cart.component';
import { ErrorService } from '../../error/error.service';
import { AppService } from '../../../app.service';
import { BuywifiService } from '../../../services/buywifi.service';
import { TravellersService } from '../../travelers/travellers.service';
import { PaymentConfirmationService } from './paymentConfirmation.service';
import { PaymentSelectionComponent } from '../../eb/paymentSelection.component';
import { ProductsComponent } from '../../products/products.component';

@Component({
  selector: 'app-paymentConfirmation',
  templateUrl: './paymentConfirmation.component.html',
  styleUrls: ['./paymentConfirmation.component.css']
})
export class PaymentConfirmationComponent implements OnInit {
  public price: number;
  public showEBforPointsBuy = PaymentSelectionComponent.showEBforPointsBuy;
  public noOfKeys: any;

  constructor(private router: Router, private errorService: ErrorService,
    private appService: AppService, private buyWifiService: BuywifiService, private travellersService: TravellersService, private paymentConfirmationService: PaymentConfirmationService) {
  }
  ngOnInit() {
    this.price = this.buyWifiService.getPointsOfferResponse().points;
    this.noOfKeys = this.buyWifiService.getSessionValue();
  }
  closePayConfirmationOverlay() {  
    CartComponent.showPaymentConfirmationScreen = false;
  }
  proceedToPayWithEB() {
    this.closePayConfirmationOverlay();
    this.appService.showLoader();
    const sessionId = this.appService.getSessionId();
    const offerId = this.buyWifiService.getPointsOfferResponse().offerId;    

    this.paymentConfirmationService.doOrderCall(sessionId, offerId, this.noOfKeys).subscribe(
      orderCallResponse => {
        if(orderCallResponse != null && orderCallResponse.status != null && 
          orderCallResponse.status && orderCallResponse.status.code == "PAID") {            
            this.buyWifiService.setOrderResponse(orderCallResponse);
            this.appService.hideLoader();
            this.router.navigate(['buywifi/confirmation']);
          } else if(orderCallResponse !=null && orderCallResponse.errors != null && orderCallResponse.errors[0].errorCode == "7011055" && this.noOfKeys > 1) {              
              PaymentSelectionComponent.showEBforPointsBuy = true;
              this.appService.hideLoader();
              this.router.navigate(['buywifi/product']);
              ProductsComponent.showAlternativePaymentConfirmationScreen = true;
         //  'Unfortunately, your profile does not have sufficient points to complete the purchase.'
         } else if(orderCallResponse !=null && orderCallResponse.errors != null && orderCallResponse.errors[0].errorCode == "7011055" && this.noOfKeys == 1) {
            this.errorService.addError(this.getErrorMessage(7011064));
            PaymentSelectionComponent.showEBforPointsBuy = false;
            this.appService.hideLoader();
            this.travellersService.redirectCardFlowFromEBAfterError();            
         // 'There are not enough points in your account for this purchase. You are welcome to use a credit card for purchasing WiFi.'
        } else {
            this.errorService.addError(this.getErrorMessage(7011065));
            PaymentSelectionComponent.showEBforPointsBuy = false;
            this.appService.hideLoader();
            this.travellersService.redirectCardFlowFromEBAfterError();
         // 'Unfortunately we are unable to deduct points from your account at this time. You are welcome to use a credit card for purchasing WiFi.
        }        
      },
      error => {
        this.errorService.addError(this.buyWifiService.getDefaultError());
        this.appService.hideLoader();
        this.appService.hideLoaderWithText();
      }
    )
  }

  getErrorMessage(errorcode): any[] {    
    return [{ 'errorCode': errorcode }];
  }
}
